function domDiff(baseHTML, comparedHTML, diffCallback) {
  const baseDomWalker = createDomWaker(baseHTML);
  const comparedDomWalker = createDomWaker(comparedHTML);
  const results = performDiffAnalysis(baseDomWalker, comparedDomWalker);
  if (results.length > 0) {
    diffCallback(results);
  }
}
function createDomWaker(htmlString) {
  const parser = new DOMParser();
  const dom = parser.parseFromString(htmlString, 'text/html');
  return dom.createTreeWalker(dom.body, NodeFilter.SHOW_ELEMENT);
}
function trimNodeWhitespace(node) {
  // Ensures we are not dealing with an SVG class object but rather an HTML class string
  if (node.className && typeof node.className === 'string') {
    node.className = node.className.trim();
  }
  for (const attr of node.attributes) {
    attr.value = attr.value.trim();
  }
}
function nodesAreDifferent(nodeA, nodeB) {
  const cloneA = nodeA.cloneNode(false);
  const cloneB = nodeB.cloneNode(false);

  // Removes false positives in data caused by whitespace differences
  trimNodeWhitespace(cloneA);
  return !cloneA.isEqualNode(cloneB);
}
function performDiffAnalysis(baseDomWalker, comparedDomWalker) {
  let baseDomNode = baseDomWalker.currentNode;
  let comparedDomNode = comparedDomWalker.currentNode;
  const diffsFound = [];
  while (baseDomNode && comparedDomNode) {
    if (nodesAreDifferent(baseDomNode, comparedDomNode)) {
      var _baseDomNode, _comparedDomNode;
      diffsFound.push({
        base: (_baseDomNode = baseDomNode) == null ? void 0 : _baseDomNode.outerHTML,
        compared: (_comparedDomNode = comparedDomNode) == null ? void 0 : _comparedDomNode.outerHTML
      });
    }
    baseDomNode = baseDomWalker.nextNode();
    comparedDomNode = comparedDomWalker.nextNode();
  }
  return diffsFound;
}

export { domDiff };
